import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/layout/Footer';
import { usePWA } from '../hooks/usePWA';
import { useState } from 'react';
import { Icons } from '../components/import/ImportIcons';

const DownloadPage = () => {
  const { supportsPWA, handleInstallClick, isPWAInstalled, browserInfo } = usePWA();
  const [showIOSGuide, setShowIOSGuide] = useState(false);
  const APP_URL = process.env.APP_URL;
  const platforms = [
    {
      name: "Windows",
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 5.45L9.88 4.43V11.26H3V5.45M21 5.45V11.26H10.88V4.43L21 5.45M3 12.74H9.88V19.57L3 18.55V12.74M10.88 19.57V12.74H21V18.55L10.88 19.57Z" />
        </svg>
      ),
      description: "Desktop app for Windows 10/11",
      downloadLink: "#",
      version: "v2.4.1",
      size: "85 MB"
    },
    {
      name: "macOS",
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5M13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
        </svg>
      ),
      description: "Desktop app for macOS 10.15+",
      downloadLink: "#",
      version: "v2.4.1",
      size: "92 MB"
    },
    {
      name: "Linux",
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
          <path d="M14.62 8.35C15.72 8.35 16.62 7.45 16.62 6.35S15.72 4.35 14.62 4.35 12.62 5.25 12.62 6.35 13.5 8.35 14.62 8.35M9.38 8.35C10.48 8.35 11.38 7.45 11.38 6.35S10.48 4.35 9.38 4.35 7.38 5.25 7.38 6.35 8.28 8.35 9.38 8.35M15.88 11.59C15.66 12.54 15.32 13.46 14.89 14.32L12 20L9.11 14.32C8.68 13.46 8.34 12.54 8.12 11.59L8 11L12 11L16 11L15.88 11.59Z" />
        </svg>
      ),
      description: "AppImage for Linux distributions",
      downloadLink: "#",
      version: "v2.4.1",
      size: "78 MB"
    },
    {
      name: "iOS",
      icon: (
        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5M13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
        </svg>
      ),
      description: "Install as Web App on iOS",
      version: "v2.4.1",
      size: "~2 MB"
    },
    {
      name: "Android",
      icon: (


        <svg
          className="w-8 h-8 mr-2"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M17.523 15.3414c-.5511 0-1.0022-.4562-1.0022-.9847 0-.5285.4511-.9847 1.0022-.9847.5511 0 1.0022.4562 1.0022.9847 0 .5285-.4511.9847-1.0022.9847m-11.046 0c-.5511 0-1.0022-.4562-1.0022-.9847 0-.5285.4511-.9847 1.0022-.9847.5511 0 1.0022.4562 1.0022.9847 0 .5285-.4511.9847-1.0022.9847m11.4252-6.585l1.8837-3.2662c.1041-.1937.0365-.4492-.1576-.5533-.1941-.1041-.4496-.0365-.5537.1572l-1.9072 3.3101c-1.3541-.6003-2.8776-.9384-4.5028-.9384-1.6252 0-3.1487.3381-4.5029.9384L6.3246 5.0941c-.1041-.1937-.3596-.2613-.5537-.1572-.194.1041-.2617.3596-.1576.5533l1.8837 3.2662c-3.4934 1.8484-5.8393 5.3733-5.8393 9.4465h20.0045c0-4.0732-2.3459-7.5981-5.8393-9.4465" />
        </svg>
      ),
      description: "Install as Web App on Android",
      version: "v2.4.1",
      size: "~2 MB"
    }
  ];


  const browserExtensions = [
    {
      name: "Chrome",
      icon: (
        <Icons.chrome className="w-8 h-8" />
      ),
      description: "Chrome Web Store",
      users: "2M+ users",
      rating: "4.8",
      downloadLink: "#"
    },
    {
      name: "Firefox",
      icon: (
        <Icons.Firefox className="w-8 h-8" />
      ),
      description: "Firefox Add-ons",
      users: "850K+ users",
      rating: "4.7",
      downloadLink: "#"
    },
    {
      name: "Safari",
      icon: (
        <Icons.Safari className="w-8 h-8" />
      ),
      description: "Safari Extensions",
      users: "500K+ users",
      rating: "4.6",
      downloadLink: "#"
    },
    {
      name: "Edge",
      icon: (
        <Icons.Edge className="w-8 h-8" />
      ),
      description: "Edge Add-ons",
      users: "300K+ users",
      rating: "4.5",
      downloadLink: "#"
    }
  ];

  const features = [
    "Auto-fill passwords across all platforms",
    "Secure password generator",
    "Cross-device synchronization",
    "Two-factor authentication support",
    "Secure sharing capabilities",
    "Dark web monitoring",
    "Password health reports",
    "Offline access to your vault"
  ];

  // Android icon component
  const AndroidIcon = () => (
    <svg 
      className="w-6 h-6 mr-2" 
      viewBox="0 0 24 24" 
      fill="currentColor"
    >
      <path d="M17.523 15.3414c-.5511 0-1.0022-.4562-1.0022-.9847 0-.5285.4511-.9847 1.0022-.9847.5511 0 1.0022.4562 1.0022.9847 0 .5285-.4511.9847-1.0022.9847m-11.046 0c-.5511 0-1.0022-.4562-1.0022-.9847 0-.5285.4511-.9847 1.0022-.9847.5511 0 1.0022.4562 1.0022.9847 0 .5285-.4511.9847-1.0022.9847m11.4252-6.585l1.8837-3.2662c.1041-.1937.0365-.4492-.1576-.5533-.1941-.1041-.4496-.0365-.5537.1572l-1.9072 3.3101c-1.3541-.6003-2.8776-.9384-4.5028-.9384-1.6252 0-3.1487.3381-4.5029.9384L6.3246 5.0941c-.1041-.1937-.3596-.2613-.5537-.1572-.194.1041-.2617.3596-.1576.5533l1.8837 3.2662c-3.4934 1.8484-5.8393 5.3733-5.8393 9.4465h20.0045c0-4.0732-2.3459-7.5981-5.8393-9.4465" />
    </svg>
  );

  const getMobileDownloadButton = (platform: any) => {
    if (platform.name === 'iOS' || platform.name === 'Android') {
      // If PWA is already installed
      if (isPWAInstalled) {
        return (
          <button
            className="w-full inline-flex items-center justify-center px-6 py-4 bg-green-100 text-green-600 font-semibold rounded-xl cursor-not-allowed"
            disabled
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            App Installed
          </button>
        );
      }

      // For Android
      if (platform.name === 'Android') {
        // Show install button only if PWA is supported and using Chrome
        if (browserInfo.isChrome && supportsPWA) {
          return (
            <button
              onClick={handleInstallClick}
              className="w-full inline-flex items-center justify-center px-6 py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors duration-200"
            >
              <AndroidIcon />
              Install Web App
            </button>
          );
        }

        // Show "Use Chrome" message if not using Chrome
        if (!browserInfo.isChrome) {
          return (
            <div className="w-full text-center">
              <p className="text-sm text-gray-600 mb-2">
                Please open in Chrome browser to install
              </p>
              <button
                className="w-full inline-flex items-center justify-center px-6 py-4 bg-gray-100 text-gray-600 font-semibold rounded-xl cursor-not-allowed"
                disabled
              >
                <AndroidIcon />
                Use Chrome Browser
              </button>
            </div>
          );
        }
      }

      // For iOS - Show installation instructions
      if (platform.name === 'iOS') {
        return (
          <div className="w-full">
            <button
              className="w-full inline-flex items-center justify-center px-6 py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors duration-200"
              onClick={() => setShowIOSGuide(true)}
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
              Install on iOS
            </button>
            <p className="mt-2 text-sm text-gray-500 text-center">
              Install via Safari browser
            </p>
          </div>
        );
      }

      // Fallback for unsupported browsers
      return (
        <div className="w-full text-center">
          <p className="text-sm text-gray-600 mb-2">
            Please open this page in {platform.name === 'iOS' ? 'Safari' : 'Chrome'} to install
          </p>
          <button
            className="w-full inline-flex items-center justify-center px-6 py-4 bg-gray-100 text-gray-600 font-semibold rounded-xl cursor-not-allowed"
            disabled
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            Browser Not Supported
          </button>
        </div>
      );
    }

    // For desktop platforms
    return (
      <button
        className="w-full inline-flex items-center justify-center px-6 py-4 bg-gray-100 text-gray-600 font-semibold rounded-xl cursor-not-allowed"
        disabled
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        Coming Soon
      </button>
    );
  };

  const renderMobileSection = () => (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Mobile Applications
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Take your passwords with you wherever you go with our mobile apps for iOS and Android.
            {supportsPWA && !isPWAInstalled && (
              <span className="block mt-2 text-blue-600">
                Install our web app for the best mobile experience!
              </span>
            )}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {platforms.slice(3, 5).map((platform, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 mr-4">
                  {platform.icon}
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">{platform.name}</h3>
                  <p className="text-gray-600">{platform.description}</p>
                </div>
              </div>

              <div className="flex justify-between items-center mb-6 text-sm text-gray-500">
                <span>Version: {platform.version}</span>
                <span>Size: {platform.size}</span>
              </div>

              {getMobileDownloadButton(platform)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const IOSInstallGuide = () => (
    <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center ${showIOSGuide ? '' : 'hidden'}`}>
      <div className="bg-white rounded-2xl p-6 m-4 max-w-sm w-full">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-bold text-gray-900">Install on iOS</h3>
          <button
            onClick={() => setShowIOSGuide(false)}
            className="text-gray-400 hover:text-gray-500"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3">
              1
            </div>
            <p className="text-gray-600">Open in Safari browser</p>
          </div>

          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3">
              2
            </div>
            <p className="text-gray-600">Tap the Share button</p>
          </div>

          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3">
              3
            </div>
            <p className="text-gray-600">Select "Add to Home Screen"</p>
          </div>

          <div className="flex items-center">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-3">
              4
            </div>
            <p className="text-gray-600">Tap "Add" to install</p>
          </div>
        </div>


        <button
          onClick={() => setShowIOSGuide(false)}
          className="mt-6 w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );

  return (
    <div className="bg-white">
      <Navbar />

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Download SecureVault
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Access your passwords securely from any device, anywhere. Available on all major platforms.
            </p>
          </div>
        </div>
      </div>

      {/* Desktop Apps */}
      {/* <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Desktop Applications
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Native desktop apps with full offline support and seamless integration with your operating system.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {platforms.slice(0, 3).map((platform, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 mr-4">
                    {platform.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">{platform.name}</h3>
                    <p className="text-gray-600">{platform.description}</p>
                  </div>
                </div>
                
                <div className="flex justify-between items-center mb-6 text-sm text-gray-500">
                  <span>Version: {platform.version}</span>
                  <span>Size: {platform.size}</span>
                </div>

                <a
                  href={platform.downloadLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full inline-flex items-center justify-center px-6 py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors duration-200"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Download for {platform.name}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Mobile Apps - Updated */}
      {renderMobileSection()}

      {/* Browser Extensions */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Browser Extensions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Auto-fill passwords and secure your browsing experience with our trusted browser extensions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {browserExtensions.map((extension, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow duration-300">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 mx-auto mb-4">
                    {extension.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{extension.name}</h3>
                  <p className="text-gray-600 text-sm mb-4">{extension.description}</p>

                  <div className="flex items-center justify-center mb-4 text-sm text-gray-500">
                    <span className="mr-4">{extension.users}</span>
                    <div className="flex items-center">
                      <svg className="w-4 h-4 text-yellow-400 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                      <span>{extension.rating}</span>
                    </div>
                  </div>

                  <a
                    href={extension.downloadLink}
                    className="w-full inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200"
                  >
                    Add to {extension.name}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Everything You Need, Everywhere
              </h2>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                No matter which platform you choose, you'll get the full SecureVault experience with
                all the features you need to stay secure online.
              </p>

              <div className="grid grid-cols-1 gap-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <svg className="w-6 h-6 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
                <div className="text-center">
                  <svg className="w-20 h-20 mx-auto mb-6 text-white opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z M8 7h8 M8 11h8 M8 15h4" />
                  </svg>
                  <h3 className="text-2xl font-bold mb-4">Cross-Platform Sync</h3>
                  <p className="text-blue-100 text-lg mb-6">
                    Your passwords stay in sync across all your devices automatically and securely.
                  </p>
                  <div className="flex justify-center space-x-4">
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </div>
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </div>
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* System Requirements */}
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              System Requirements
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              SecureVault runs on most modern devices and operating systems.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Windows</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Windows 10 or later</li>
                <li>• 100 MB available storage</li>
                <li>• Internet connection required</li>
                <li>• 2 GB RAM minimum</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">macOS</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• macOS 10.15 or later</li>
                <li>• 120 MB available storage</li>
                <li>• Internet connection required</li>
                <li>• 2 GB RAM minimum</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Mobile</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• iOS 13.0+ or Android 7.0+</li>
                <li>• 50 MB available storage</li>
                <li>• Internet connection required</li>
                <li>• Biometric authentication supported</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-20 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            Download SecureVault on all your devices and start securing your digital life today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/signup"
              className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-xl text-blue-600 bg-white hover:bg-gray-50 transition-colors duration-200"
            >
              Start Free Trial
            </a>
            <a
              href="/pricing"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-lg font-medium rounded-xl text-white hover:bg-white hover:text-blue-600 transition-colors duration-200"
            >
              View Pricing
            </a>
          </div>
        </div>
      </div>

      <IOSInstallGuide />
      <Footer />
    </div>
  );
};

export default DownloadPage;
